// Revamped ChalanView component for Chalan (Delivery Note) purpose

import React, { Component, createRef } from "react";
import "./chalan.scss";
import ReactToPrint from "react-to-print";

export class ChalanViewBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      componentRef: createRef(),
      estimationData: {},
      assetData: [],
      vendorDetails: {},
      instituteName: "",
      instituteDetails: "",
      quotationNumber:"",
      quotationDate:""
    };
  }

  componentDidMount() {
    const { data } = this.props;
    const { poData, vendorDetails, instituteName, instituteDetails } = data;

    const prDetails = Object.values(poData.prDetails);

    
    const assetData = prDetails.map((item) => ({
      name: item.catalogName,
      quantity: item.deliveryQuantity,
      actualAmount: item.actualAmount,
      gst: item.gst,
      discount: item.discount,
      amount: item.deliveryQuantity * item.amountPerUnit,
    }));

    const totalQuantity = assetData.reduce((sum, a) => sum + a.quantity, 0);
    const totalAmount = assetData.reduce((sum, a) => sum + a.amount, 0);

    this.setState({
      estimationData: {
        totalQuantity,
        totalAmount,
        addedOnDate: new Date(),
      },
      assetData,
      vendorDetails,
      instituteName,
      instituteDetails,
      quotationNumber:poData.quotationNumber,
      quotationDate:poData.expectedDate,
    });
  }

  formatDate = (dateString) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const date = new Date(dateString);

    if (isNaN(date)) {
      return "Invalid Date";
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  render() {
    const { estimationData, assetData, vendorDetails, instituteName , instituteDetails} =
      this.state;

      

    // First, calculate totals
    const totalQuantity = assetData.reduce(
      (sum, item) => sum + Number(item.quantity || 0),
      0
    );
    const totalActualAmount = assetData.reduce(
      (sum, item) =>
        sum + Number(item.actualAmount || 0) * Number(item.quantity || 0),
      0
    );
    const totalTax = assetData.reduce(
      (sum, item) =>
        sum +
        Number(item.actualAmount || 0) *
          Number(item.quantity || 0) *
          (Number(item.gst || 0) / 100),
      0
    );
    const totalDiscount = assetData.reduce(
      (sum, item) =>
        sum +
        Number(item.actualAmount || 0) *
          Number(item.quantity || 0) *
          (Number(item.discount || 0) / 100),
      0
    );
    const grandTotal = totalActualAmount + totalTax - totalDiscount;

    return (
      <div className="approvalTable">
       
        <div className="approvalForm" ref={this.state.componentRef}>
          <div className="flex-col-approval">
            <div className="flex-row-approval">
              <p className="vm_custom_title4">{vendorDetails.vendorName}</p>
            </div>
            <div className="flex-row-approval">
              <span className="vm_custom_overline">
                {vendorDetails.address?.address}, {vendorDetails.address?.city},
                {vendorDetails.address?.state}, {vendorDetails.address?.country}
                ,{vendorDetails.address?.zipcode}
              </span>
              <span
                className="vm_custom_overline"
                style={{ justifyContent: "flex-end" }}
              >
                {vendorDetails.phone && (
                  <p className="vm_custom_overline">
                    Tel: {vendorDetails.phone}
                  </p>
                )}
                {vendorDetails.email && (
                  <p className="vm_custom_overline">
                    Email: {vendorDetails.email}
                  </p>
                )}
              </span>
            </div>
          </div>

          <div className="quotation-title">
            <span className="vm_custom_title5" style={{ color: "#FFFFFF" }}>
              DELIVERY CHALAN
            </span>
          </div>

          <div
            className="table-responsive col-md-12"
            style={{ width: "100%", maxHeight: "60vh", overflowY: "auto" }}
          >
            <table
              className="table table-bordered"
              style={{
                width: "100%",
                borderCollapse: "collapse",
                border: "1.01px solid #E0E8EF",
              }}
            >
              <thead
                style={{
                  backgroundColor: "#F5F8FA",
                  position: "sticky",
                  top: "0",
                  zIndex: 1,
                  borderBottom: "1px solid #E0E8EF",
                }}
              >
                <tr>
                  <th
                    className="vm_custom_body3"
                    style={{
                      padding: "5px 5px",
                      backgroundColor: "#F9FAFB",
                      border: "1.01px solid #E0E8EF",
                    }}
                  >
                    Customer Details
                  </th>
                  <th
                    className="vm_custom_body3"
                    style={{
                      padding: "5px 5px",
                      backgroundColor: "#F9FAFB",
                      border: "1.01px solid #E0E8EF",
                    }}
                  >
                    Request Details
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    className="table-rows vm_custom_body3"
                    style={{ border: "1.01px solid #E0E8EF" }}
                  >
                    <p className="vm_custom_body3">
                      <span style={{ fontWeight: "bold" }}>
                        Organization Name :{" "}
                      </span>
                      {instituteName}
                    </p>
                    <p className="vm_custom_body3"> Address :{instituteDetails.address}, {instituteDetails.district}</p>
                    <p className="vm_custom_body3">State :  {instituteDetails.state}</p>
                    <p className="vm_custom_body3">Phone :  {instituteDetails.phone}</p>
                  </td>
                  <td
                    className="table-rows vm_custom_body3"
                    style={{ border: "1.01px solid #E0E8EF" }}
                  >
                    <p className="vm_custom_body3">
                      <span style={{ fontWeight: "bold" }}>Quotation Number : {this.state.quotationNumber}</span>
                      {this.props.currentQueryRequestId ?? "-"}
                    </p>

                    <p className=" vm_custom_body3">
                      <span style={{ fontWeight: "bold" }}> Date : {this.formatDate(this.state.quotationDate)}</span>
                      {/* {estimationData.addedOnDate?.toString()} */}
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="table-responsive col-md-12">
            <table className="table table-bordered" style={{ width: "100%" }}>
              <thead style={{ backgroundColor: "#F5F8FA" }}>
                <tr>
                  <th>Sr. No.</th>
                  <th>Asset Name</th>
                  <th>Quantity</th>
                  <th>Amount</th>
                  <th>Tax</th>
                  <th>Discount</th>
                  <th>Total Amount (₹)</th>
                </tr>
              </thead>
              <tbody>
                {assetData.length > 0 ? (
                  assetData.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.name}</td>
                      <td>{item.quantity}</td>
                      <td>{item.actualAmount * item.quantity}</td>
                      <td>{item.gst} %</td>
                      <td>{item.discount} %</td>
                      <td>{item?.amount?.toFixed(2)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4">No delivery data found.</td>
                  </tr>
                )}
              </tbody>
              <tfoot style={{ backgroundColor: "#F5F8FA" }}>
                <tr>
                  <td></td>
                  <td>
                    <b>Total</b>
                  </td>
                  <td>
                    <b>{totalQuantity}</b>
                  </td>
                  <td>
                    <b>₹ {totalActualAmount.toFixed(2)}</b>
                  </td>
                  <td>
                    <b>₹ {totalTax.toFixed(2)}</b>
                  </td>
                  <td>
                    <b>₹ {totalDiscount.toFixed(2)}</b>
                  </td>
                  <td>
                    <b>₹ {estimationData?.totalAmount?.toFixed(2)}</b>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div className="table-responsive col-md-12">
            <table className="table table-bordered" style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td>Delivery Date:</td>
                  <td>
                    {this.formatDate(vendorDetails.deliveryDate)}
                  </td>
                </tr>
                <tr>
                  <td>Signature:</td>
                  <td></td>
                </tr>
               
              </tbody>
            </table>
          </div>

          {/* <div className="table-responsive col-md-12" style={{ width: '100%', maxHeight: '60vh', overflowY: 'auto' }}>
                        <table className="table table-bordered" style={{ width: '100%', borderCollapse: 'collapse', border: '1.01px solid #E0E8EF' }}>
                            <thead style={{ backgroundColor: "#F5F8FA", position: 'sticky', top: '0', zIndex: 1, borderBottom: '1px solid #E0E8EF' }}>
                                <tr>
                                    <th className="vm_custom_body3" style={{ padding: '5px 5px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Total in Words :

                                    </th>
                                    <th className="vm_custom_body3"
                                        style={{ padding: '5px 5px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>

                                        <span style={{ fontWeight: 'bold' }}>   Amount : </span>
                                        {estimationData.grandTotalCost ?? "#"}
                                    </th>

                                </tr>
                            </thead>
                            <tbody>

                                <tr>
                                    <td className="table-rows vm_custom_body3" style={{ border: '1.01px solid #E0E8EF' }}>
                                        <span className="vm_custom_body3">{estimationData.totalAmountInWords}</span>

                                    </td>
                                    <td className="vm_custom_body3" style={{ border: '1.01px solid #E0E8EF' }}>

                                        <p className="vm_custom_body3">

                                            <span style={{ fontWeight: 'bold' }}>SGST :  </span>
                                            {estimationData.sgst}</p>
                                        <p className="vm_custom_body3">
                                            <span style={{ fontWeight: 'bold' }}>CGST :  </span>
                                            {estimationData.cgst}</p>
                                        <p className="vm_custom_body3">

                                            <span style={{ fontWeight: 'bold' }}> Total GST Amount :   </span>
                                            {estimationData.totalGst}</p>

                                    </td>

                                </tr>

                                <tr>
                                    <td className="table-rows vm_custom_body3" style={{ border: '1.01px solid #E0E8EF' }}>
                                        <span className="vm_custom_body3"> Terms and Conditions</span>
                                    </td>

                                    <td className="table-rows vm_custom_body3" style={{ border: '1.01px solid #E0E8EF' }}>
                                        <span className="vm_custom_body3">
                                            <span style={{ fontWeight: 'bold' }}> Payable Amount:  </span>
                                            {estimationData.totalCostWithGst}</span>
                                    </td>

                                </tr>
                                <tr>
                                    <td rowSpan={3} className="vm_custom_body3" style={{ border: '1.01px solid #E0E8EF' }}>

                                        <p className="vm_custom_body3" >  Subject to Pune Jurisdiction.</p>
                                        <p className="vm_custom_body3" >   Our responsibility ceases as soon as the service delivered.</p>

                                    </td>
                                    <td className="table-rows vm_custom_body3" style={{ border: '1.01px solid #E0E8EF' }}>
                                        <span className="vm_custom_body3" style={{alignSelf:'center'}}> Signature</span>

                                    </td>

                                </tr>

                            </tbody>
                        </table>

                    </div> */}
        </div>
      </div>
    );
  }
}
const ChalanView = React.forwardRef((props, ref) => {
    return <ChalanViewBase {...props} forwardedRef={ref} />;
  });
  
export default ChalanView;
